<template>
  <div class="tracking">
    <common-layout>
      <div slot="header">
        <h3>项目跟踪</h3>
      </div>
      <div slot="container">
        <div class="tracking-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-date-picker
            v-model="time[0]"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="开始日期"
            @change="search('start')"
            style="width: 10%; margin: 0 5px 0 10px"
          >
          </el-date-picker>
          <span> - </span>
          <el-date-picker
            v-model="time[1]"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="结束日期"
            @change="search('end')"
            style="width: 10%; margin: 0 10px 0 5px"
          >
          </el-date-picker>
          <!-- <el-date-picker
            class="date-picker"
            v-model="time"
            type="daterange"
            @change="search"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 20%"
          ></el-date-picker> -->
          <label>合作方式:</label>
          <el-select
            v-model="cooperate_type"
            placeholder="请选择合作方式"
            @change="search()"
            style="width: 8%; margin: 0 15px"
          >
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>技术领域:</label>
          <el-select
            v-model="tech_field"
            placeholder="请选择技术领域"
            @change="search()"
            style="width: 8%; margin: 0 15px"
          >
            <el-option
              v-for="item in options6"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>状态:</label>
          <el-select
            v-model="status"
            placeholder="请选择状态"
            @change="search()"
            style="width: 8%; margin: 0 15px"
          >
            <el-option
              v-for="item in options4"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 20%"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="tracking-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="80"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="项目名称"
              align="center"
              prop="name"
            ></el-table-column>
            <el-table-column label="技术需求方" align="center" prop="need">
              <!-- <template slot-scope="scope">
                {{ formaCasVal(scope.row.need_json) }}
              </template> -->
            </el-table-column>
            <el-table-column label="技术供给方" align="center" prop="provide">
              <!-- <template slot-scope="scope">
                {{ formaCasVal(scope.row.provide_json) }}
              </template> -->
            </el-table-column>
            <el-table-column
              label="技术领域"
              align="center"
              prop="tech_field_name"
            >
              <!-- <template slot-scope="scope">
                {{ formaCasVal(scope.row.provide_json) }}
              </template> -->
            </el-table-column>
            <el-table-column
              label="合作方式"
              align="center"
              prop="cooperate_type_name"
            >
              <!-- <template slot-scope="scope">
                <span>{{
                  scope.row.cooperate_type == 1
                    ? "技术开发"
                    : scope.row.cooperate_type == 2
                    ? "技术转让"
                    : scope.row.cooperate_type == 3
                    ? "技术咨询"
                    : "技术服务"
                }}</span>
              </template> -->
            </el-table-column>
            <el-table-column
              label="成果转化交易额（万元）"
              align="center"
              prop="money"
              width="120"
            >
              <!-- <template slot-scope="scope">
                {{ formaCasVal(scope.row.provide_json) }}
              </template> -->
            </el-table-column>
            <el-table-column label="状态" align="center" prop="status_name">
              <!-- <template slot-scope="scope">
                <span>{{
                  scope.row.status == 1
                    ? "拟对接"
                    : scope.row.status == 2
                    ? "正在对接"
                    : scope.row.status == 3
                    ? "合作意向"
                    : "签订协议"
                }}</span>
              </template> -->
            </el-table-column>
            <el-table-column
              label="当前状态日期"
              align="center"
              prop="formate_status_time"
            ></el-table-column>
            <el-table-column width="180px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      class="trackingDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="项目名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术需求方" prop="need">
              <el-input
                v-model="ruleForm.need"
                placeholder="请输入技术需求方"
              ></el-input>
              <!-- <el-cascader
                :props="cascaderProps"
                :options="optionsTree"
                clearable
                v-model="ruleForm.need"
              ></el-cascader> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术供给方" prop="provide">
              <el-col :span="20">
                <el-input
                  v-model="ruleForm.provide"
                  placeholder="请输入技术供给方"
                ></el-input>
                <!-- <el-cascader
                  :props="cascaderProps"
                  :options="optionsTree"
                  clearable
                  v-model="ruleForm.provide"
                ></el-cascader> -->
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="技术领域" prop="tech_field">
          <el-select
            style="width: 100%"
            v-model="ruleForm.tech_field"
            placeholder="请选择技术领域"
          >
            <el-option
              v-for="item in options5"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作方式" prop="cooperate_type">
          <el-select
            style="width: 100%"
            v-model="ruleForm.cooperate_type"
            placeholder="请选择合作方式"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            style="width: 100%"
            v-model="ruleForm.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="成果转移转化交易额"
          prop="money"
          v-if="ruleForm.status == 4"
          label-width="150px"
        >
          <el-input
            v-model="ruleForm.money"
            placeholder="请输入成果转移转化交易额"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前状态时间" prop="status_time">
          <el-date-picker
            v-model="ruleForm.status_time"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item
          label="文件上传"
          prop="uploadFile"
          class="avatar-uploader"
        >
          <el-upload
            class="upload-demo"
            multiple
            accept=".jpg, .jpeg, .png, .pdf"
            :action="uploadURL"
            :on-remove="onRemove"
            :file-list="fileList"
            :on-preview="onPreview"
            :on-success="handleAvatarSuccess"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="loading_btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import { FunDownload, CheckTimeLine } from "../../utils/tool";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      loading_btn: false,
      fileList: [],
      tech_field: "",
      cooperate_type: "",
      status: 0,
      optionsTree: [],
      need_json: [],
      provide_json: [],
      operateUserId: "",
      cascaderProps: {
        value: "id",
        label: "name",
        children: "sub",
      },
      options3: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "委托开发",
        },
        {
          value: 2,
          label: "许可转让",
        },
        {
          value: 3,
          label: "完全转让",
        },
        {
          value: 4,
          label: "技术入股",
        },
        {
          value: 5,
          label: "技术许可",
        },
        {
          value: 6,
          label: "合作转化",
        },
        {
          value: 7,
          label: "其他",
        },
      ],
      options4: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "拟对接",
        },
        {
          value: 2,
          label: "正在对接",
        },
        {
          value: 3,
          label: "合作意向",
        },
        {
          value: 4,
          label: "签订协议",
        },
      ],
      total: 10,
      per_page: 10,
      current_page: 1,
      time: [],
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      deleteRow: "",
      options: [
        {
          value: 1,
          label: "委托开发",
        },
        {
          value: 2,
          label: "许可转让",
        },
        {
          value: 3,
          label: "完全转让",
        },
        {
          value: 4,
          label: "技术入股",
        },
        {
          value: 5,
          label: "技术许可",
        },
        {
          value: 6,
          label: "合作转化",
        },
        {
          value: 7,
          label: "其他",
        },
      ],
      options1: [
        {
          value: 1,
          label: "拟对接",
        },
        {
          value: 2,
          label: "正在对接",
        },
        {
          value: 3,
          label: "合作意向",
        },
        {
          value: 4,
          label: "签订协议",
        },
      ],
      options5: [
        {
          value: 1,
          label: "新能源",
        },
        // {
        //   value: 2,
        //   label: "清洁生产",
        // },
        // {
        //   value: 3,
        //   label: "清洁能源",
        // },
        {
          value: 4,
          label: "现代农业",
        },
        {
          value: 5,
          label: "生物医药",
        },
        {
          value: 6,
          label: "文化旅游",
        },
        {
          value: 7,
          label: "通道物流",
        },
        {
          value: 8,
          label: "数据信息",
        },
        {
          value: 9,
          label: "军民融合",
        },
        {
          value: 10,
          label: "装备制造",
        },
      ],
      options6: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "新能源",
        },
        // {
        //   value: 2,
        //   label: "清洁生产",
        // },
        // {
        //   value: 3,
        //   label: "清洁能源",
        // },
        {
          value: 4,
          label: "现代农业",
        },
        {
          value: 5,
          label: "生物医药",
        },
        {
          value: 6,
          label: "文化旅游",
        },
        {
          value: 7,
          label: "通道物流",
        },
        {
          value: 8,
          label: "数据信息",
        },
        {
          value: 9,
          label: "军民融合",
        },
        {
          value: 10,
          label: "装备制造",
        },
      ],
      is_submit: true,
      tableData: [],
      ruleForm: {
        name: "",
        // contract: "",
        need: "",
        // need_json: "",
        provide: "",
        // provide_json: "",
        cooperate_type: "",
        tech_field: "",
        status: "",
        money: "",
        status_time: "",
        // day: "",
        // status: "",
        // number: "",
        // day_one: "",
        // day_two: "",
        // day_three: "",
        // day_four: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        need: [
          {
            required: true,
            message: "请输入技术需求方",
            trigger: "blur",
          },
        ],
        provide: [
          {
            required: true,
            message: "请输入技术供给方",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择合作方式",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        number: [
          {
            required: true,
            message: "请输入成果转移转化交易额",
            trigger: "blur",
          },
        ],
        day: [
          {
            type: "string",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    // this.getData("project_track", 1);
    this.getData();
    // this.getTreeJson();
  },
  methods: {
    formaCasVal(val) {
      if (val) {
        let arrs = JSON.parse(val);
        let parent = [],
          subs = [],
          subs_s = [];
        parent = this.optionsTree.filter((el) => {
          return el.id == arrs[0];
        });
        subs =
          parent.length > 0 &&
          parent[0].sub &&
          parent[0].sub.filter((el) => {
            return el.id == arrs[1];
          });
        subs_s =
          subs &&
          subs[0].sub &&
          subs[0].sub.filter((el) => {
            return el.id == arrs[2];
          });
        return subs_s ? subs_s[0].name : subs ? subs[0].name : parent[0].name;
      }
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    // 获取树
    async getTreeJson() {
      let res = await this.http.get("/Unit?all_sub=1");
      if (res.code == 0) {
        this.optionsTree = res.data.data.tree;
      }
      console.log("获取树", this.optionsTree);
    },
    onRemove(file, fileList) {
      this.fileList = fileList;

      // this.fileList = fileList.slice(-3);
    },

    // 上传成功
    handleAvatarSuccess(response, file, fileList) {
      this.fileList = fileList.map((el) => {
        return {
          name: el.name,
          url: el?.response?.data?.store_result || el?.url,
        };
      });
    },

    getData(url, type) {
      let params = {
        page: this.current_page,
        keyword: this.searchValue,
        cooperate_type: this.cooperate_type || '',
        tech_field: this.tech_field || '',
        status: this.status || '',
        start_time: this.time.length>0?this.time[0] : "",
        end_time: this.time.length>1?this.time[1] : ""
      };

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/project-track/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data?.total || 0;
          this.per_page = res.data?.per_page || 10;
          this.current_page = res.data?.current_page || 1;
          if (type) {
            let tree = res.data.cooperate_types;
            this.options3 = [
              {
                value: 0,
                label: "全部",
              },
            ];
            this.options = [];
            for (var d in tree) {
              console.log(typeof d)
              this.options.push({
                value: Number(d),
                label: tree[d]
              })
              this.options3.push({
                value: Number(d),
                label: tree[d]
              })
            }
          }
        }
      });
    },
    //新增
    addEvent() {
      this.is_submit = true;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        // contract: "",
        need: "",
        // need_json: "",
        provide: "",
        // provide_json: "",
        cooperate_type: "",
        tech_field: "",
        status: "",
        money: "",
        status_time: "",
        // day: "",
        // status: "",
        // number: "",
        // day_one: "",
        // day_two: "",
        // day_three: "",
        // day_four: "",
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/project-track/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.ResetSearch([
                    "cooperate_type",
                    "tech_field",
                    "status",
                    "searchValue",
                  ]);
                  this.time = [];
                  this.getData()
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search(type) {
      if (this.time.filter((d) => d).length === 2) {
        let flag = CheckTimeLine(this.time[0], this.time[1]);

        if (flag) {
          if (type === "start") {
            this.$set(this.time, 0, "");
          } else {
            this.$set(this.time, 1, "");
          }

          return false;
        }
      }
      this.current_page = 1;
      this.getData(
        "project_track?keyword=" +
          this.searchValue +
          (this.cooperate_type
            ? "&cooperate_type=" + this.cooperate_type
            : "") +
          (this.tech_field ? "&tech_field=" + this.tech_field : "") +
          (this.status ? "&status=" + this.status : "") +
          "&start_time=" +
          (this?.time[0] || "") +
          "&end_time=" +
          (this?.time[1] || "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      console.log(row);
      this.dialogFormVisible = true;
      // this.fileList = [];
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.status_time = row.formate_status_time;
      this.ruleForm.cooperate_type =
        row.cooperate_type == 0 ? "" : row.cooperate_type;
      this.ruleForm.tech_field = row.tech_field == 0 ? "" : row.tech_field;
      // this.ruleForm.need = JSON.parse(this.ruleForm.need_json);
      // this.ruleForm.provide = JSON.parse(this.ruleForm.provide_json);
      // this.fileList = this.ruleForm.contract?.split(",").map((el, index) => {
      //   let arr = el.split("/");
      //   return {
      //     url: el,
      //     // uid: new Date().valueOf()
      //     name: arr[arr.length - 1],
      //   };
      // });
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/project-track/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch([
                  "time",
                  "cooperate_type",
                  "tech_field",
                  "status",
                  "searchValue",
                ]);
                this.getData();
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.current_page = e;
      this.getData(
        "project_track?keyword=" +
          this.searchValue +
          "&page=" +
          e +
          (this.cooperate_type
            ? "&cooperate_type=" + this.cooperate_type
            : "") +
          (this.tech_field ? "&tech_field=" + this.tech_field : "") +
          (this.status ? "&status=" + this.status : "") +
          "&start_time=" +
          (this?.time[0] || "") +
          "&end_time=" +
          (this?.time[1] || "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading_btn = true;
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          // obj.need_json = obj.need;
          // obj.provide_json = obj.provide;
          // obj.need = obj.need[obj.need.length - 1];
          // obj.provide = obj.provide[obj.provide.length - 1];
          // if (obj.status == 1) {
          //   obj.day_one = obj.day;
          // } else if (obj.status == 2) {
          //   obj.day_two = obj.day;
          // } else if (obj.status == 3) {
          //   obj.day_three = obj.day;
          // } else {
          //   obj.day_four = obj.day;
          // }
          // obj.need_json = JSON.stringify(obj.need_json);
          // obj.provide_json = JSON.stringify(obj.provide_json);
          // let tmpList = this.fileList.map((el) => el.url);
          // obj.contract = tmpList.join(",");
          obj.statusTimeStr = obj.status_time || null;
          delete obj.status_time;
          if (!this.ruleForm.id) {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/project-track/create`, obj)
              .then((res) => {
                this.loading_btn = false;
                if (res.code == 0) {

                  this.$message({
                    type: "success",
                    message: "新增成功",
                  });
                  this.ResetSearch([
                    "cooperate_type",
                    "tech_field",
                    "status",
                    "searchValue",
                  ]);
                  this.time = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                  this.current_page = 1;
                  this.getData();
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
          if (this.Title == "编辑") {
            // delete obj.id;
            obj.id = this.ruleForm.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/project-track/update`, obj)
              .then((res) => {
                this.loading_btn = false;
                if (res.code == 0) {

                  this.$message({
                    type: "success",
                    message: "编辑成功",
                  });
                  this.ResetSearch([
                    "cooperate_type",
                    "tech_field",
                    "status",
                    "searchValue",
                  ]);
                  this.time = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                  this.current_page = 1;
                  this.getData()
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scope>
.upload-demo {
  border: 1px dashed #cccccc;
}

.tracking {
  height: 100%;
  width: 100%;

  .tracking-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /deep/label {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    /deep/.el-input-group {
      width: 30%;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .tracking-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
</style>
<style lang='scss'>
.trackingDialog {
  .el-cascader {
    width: 100%;
  }

  .el-col-20 {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
}
</style>
